<template>
    <div>
        <template v-for="(record, i) in activityRecord">
            <div class="col-12 check-in-bar d-flex align-items-center justify-content-between"
                 style="margin-bottom: 12px;"
                 :style="{'border-left': `${availabilityColor(record.user_availability_log_ref.status)}` + ' 4px solid'}">
                <div class="wfh-paragraph" style="color: #303030;">
                    {{ userStatus(record) }}
                </div>
                <div class="wfh-form-label">
                    {{ formatTime(record.created_at) }}
                </div>
            </div>
        </template>
        <div v-if="activityRecord.length < 1" class="col-12 text-muted text-center">
            No data available.
        </div>
    </div>
</template>

<script>
    import moment from "moment-timezone";

    export default {
        props: {
            activityRecord: {
                type: Array,
                default: () => []
            },
            timezone: {
                type: String,
                default: null,
            }
        },
        methods: {
            availabilityText(availability) {
                return (
                    {
                        check_in: "just checked in",
                        continue: "continued from break or away",
                        check_out: "just checked out",
                        break: "on break",
                        away: "went away"
                    }[availability] || "checked out"
                );
            },

            availabilityColor(availability) {
                return (
                    {
                        check_in: "#82DF6B",
                        continue: "#82DF6B",
                        check_out: "#FF4444",
                        break: "#E0E0E0",
                        away: "#FFE171"
                    }[availability] || "#E0E0E0"
                );
            },

            formatTime(time) {
                return this.timezone
                    ? moment
                        .utc(time)
                        .tz(this.timezone)
                        .format("h:mm A")
                    : moment
                        .utc(time)
                        .local()
                        .format("h:mm A");
            },

            userStatus(record) {
                const name = record.user.display_name || record.user.name;
                return `${name} ${this.availabilityText(record.user_availability_log_ref.status)}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    $opacity-types: 30, 60;
    @each $opacity in $opacity-types {
        .opacity-#{$opacity} {
            opacity: $opacity/100;
        }
    }

    .check-in-bar {
        height: 48px;
        border-radius: 4px;
        background-color: #FFFFFF;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
    }
</style>
